import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { MermaidBlock } from "./MermaidBlock";

// ```mermaid fences in .md files render as diagrams (same block as chat); other fences stay as code.
const mdComponents = {
  pre({ children }) {
    const c = React.Children.toArray(children)[0];
    if (/language-mermaid/.test(c?.props?.className || "")) return <MermaidBlock code={String(c.props.children ?? "").replace(/\n$/, "")} />;
    return <pre>{children}</pre>;
  },
};

// Original-format preview for knowledge files: .docx → HTML (mammoth, in the browser), .md → rendered markdown, .txt → monospace.
export function DocPreview({ blob, type }) {
  const [html, setHtml] = useState(null);
  const [text, setText] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    let alive = true;
    setHtml(null); setText(null); setErr("");
    (async () => {
      try {
        if (type === "docx") {
          const mammoth = await import("mammoth/mammoth.browser");
          const r = await mammoth.convertToHtml({ arrayBuffer: await blob.arrayBuffer() }, { styleMap: ["p[style-name='Title'] => h1:fresh", "p[style-name='Subtitle'] => h2:fresh"] });
          if (alive) setHtml(r.value);
        } else if (alive) setText(await blob.text());
      } catch (e) { if (alive) setErr("Dokumen tidak bisa ditampilkan — gunakan tab \"Teks untuk asisten\"."); }
    })();
    return () => { alive = false; };
  }, [blob, type]);
  if (err) return <p className="p-4 text-xs text-[#EF4444]">{err}</p>;
  if (html === null && text === null) return <p className="flex items-center gap-2 p-4 text-xs text-slate-500"><Loader2 size={13} className="animate-spin" /> Memuat dokumen…</p>;
  if (type === "docx") return <div className="doc-preview h-full overflow-y-auto bg-slate-100 p-4" data-testid="kn-docx-preview"><div className="mx-auto max-w-3xl rounded-xl bg-white px-8 py-6 shadow-sm" dangerouslySetInnerHTML={{ __html: html }} /></div>;
  if (type === "md") return <div className="doc-preview h-full overflow-y-auto bg-slate-100 p-4" data-testid="kn-md-preview"><div className="mx-auto max-w-3xl rounded-xl bg-white px-8 py-6 shadow-sm"><ReactMarkdown remarkPlugins={[remarkGfm]} components={mdComponents}>{text}</ReactMarkdown></div></div>;
  return <pre className="h-full overflow-y-auto whitespace-pre-wrap bg-white px-6 py-4 font-mono text-xs leading-relaxed text-slate-700" data-testid="kn-txt-preview">{text}</pre>;
}
